export enum CpxApiErrorCodeWrapperJsEnum {
    'BrowserNotSupported' = 1,
    'SocketError' = 2,
    'ConnectionClosedError' = 3,
    'UnexpectedResponse' = 4,
    'ServerTimeout' = 5,
    'InitializationError' = 6,
}
